import { Box, Button, Typography } from '@mui/material';
import menu from '../../../../../data/menu.json';
import MobileMenuCategory from './MobileMenuCategory';
import { useState } from 'react';

export default function MobileMenuPage(){
    const [activeMenu, setActiveMenu] = useState(menu.englishMenu);
    
    function handleMenuSelection(){
        if(activeMenu.locale==='en') setActiveMenu(menu.greekMenu);
        else setActiveMenu(menu.englishMenu);
    }


    return(
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{mt:8,mb:8}}
        >
            <Box
                 sx={{
                    textAlign:'right',
                    width:'80%',
                }}
            >
                <Button
                    variant='contained'
                    color='secondary'
                    onClick={handleMenuSelection}
                >
                    {activeMenu.locale === 'el'?
                        <>ENGLISH</>:
                        <>ΕΛΛΗΝΙΚΑ</>
                    }

                </Button>
            </Box>
            {activeMenu.categories.map((category)=>(
                <MobileMenuCategory category={category} activeMenuLocale={activeMenu.locale} />
            ))}

            <Box
                sx={{
                    textAlign:'left',
                    width:'80%',
                }}
            >
                <Typography sx={{m:1}}>
                    {activeMenu.appendice}
                </Typography>
            </Box>
        </Box>);

}